module.exports = __webpack_public_path__ + "static/img/Full reduction2@3x.5683e92.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/Full reduction2@3x.png
// module id = HCsZ
// module chunks = 1